export const defaultColumnWidths = {
  electric: 120,
  gas: 120,
  water: 120,
  sewer: 120,
  trash: 120,
  other: 120,
};
